import { registerListbox } from './listbox';
import { registerListboxNavigate } from './listboxNavigate';
import { registerListboxTabSwitch } from './listboxTabSwitch';
import { registerNavActive } from './nav-active';
import { registerQuizCategorization } from './quiz-categorization';

type AlpinePluginRegistrar = () => void;

const alpinePlugins: AlpinePluginRegistrar[] = [
    registerNavActive,
    registerListbox,
    registerListboxNavigate,
    registerListboxTabSwitch,
    registerQuizCategorization,
];

export function registerAlpinePlugins(): void {
    alpinePlugins.forEach(register => register());
}

export { registerListbox, registerListboxNavigate, registerListboxTabSwitch, registerNavActive, registerQuizCategorization };
